module.exports = __webpack_public_path__ + "cb566f85c7c026887f5b6b4025228e97.png";